import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import eyeImage from "../../../common/images/eye.svg";
import { TertiaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";
import { getFunctionGroupLabel } from "../../../common/utils/getFunctionGroupLabel";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { openFileInNewTab } from "../../../common/utils/openFileInNewTab";

export const mapCertificateDataToRows = (
    certificateData?: CertificateInterface[],
): TertiaryTableRow[] => {
    if (!certificateData) {
        return [];
    }

    return certificateData.map((certificate: CertificateInterface) => {
        let fileName = certificate.certificate_file.file_url?.split("/").pop();

        if (!fileName) {
            fileName = "certificate";
        }

        return {
            id: certificate.id,
            columns: [
                {
                    value: getUserFullName(certificate.employee?.user) ?? "-",
                    valueBottom: getFunctionGroupLabel(
                        certificate.employee?.function_groups,
                    ),
                },
                {
                    value: certificate?.educator?.name ?? "Geen opleider",
                },
                {
                    value: new Date(certificate.valid_at).toLocaleDateString(
                        "nl-NL",
                    ),
                },
                {
                    value: certificate.expires_at
                        ? new Date(certificate.expires_at).toLocaleDateString(
                              "nl-NL",
                          )
                        : "Geen geldigheidsduur",
                },
                {
                    value: certificate.certificate_file.file_url
                        ? "Bekijken"
                        : "Geen certificaat geüpload",
                    iconUrl: eyeImage,
                    onLinkClick: certificate.certificate_file.file_url
                        ? () =>
                              openFileInNewTab(
                                  certificate.certificate_file.file_url,
                              )
                        : undefined,
                },
            ],
        };
    });
};
